// extracted by mini-css-extract-plugin
export default {"cartContainer":"cartComponents_cartContainer__EP3NQ","cartIcon":"cartComponents_cartIcon__vfnYi","cartAmount":"cartComponents_cartAmount__nIvmA"};